export const formatFilterDate = (dateStr) => {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-');
  return `${d}/${m}/${y}`;
};

export const buildFilterChips = (filters, t, options) => {
  const chips = [];

  if (filters.client) {
    chips.push({ key: 'client', label: `${t('contracts.filterModal.fields.client')}: ${filters.client.name}` });
  }

  if (filters.company) {
    const found = options.companies.find((c) => String(c.id) === String(filters.company));
    chips.push({ key: 'company', label: `${t('contracts.filterModal.fields.company')}: ${found?.name ?? filters.company}` });
  }

  if (filters.situation) {
    const found = options.situations.find((s) => s.value === filters.situation);
    chips.push({ key: 'situation', label: `${t('contracts.filterModal.fields.situation')}: ${found?.label ?? filters.situation}` });
  }

  if (filters.status) {
    const found = options.statuses.find((s) => s.value === filters.status);
    chips.push({ key: 'status', label: `${t('contracts.filterModal.fields.status')}: ${found?.label ?? filters.status}` });
  }

  if (filters.dateStart || filters.dateEnd) {
    const from = formatFilterDate(filters.dateStart);
    const to = formatFilterDate(filters.dateEnd);
    const periodLabel = from && to
      ? `${from} – ${to}`
      : from
        ? `${t('contracts.filterModal.fields.dateStart')}: ${from}`
        : `${t('contracts.filterModal.fields.dateEnd')}: ${to}`;
    chips.push({ key: 'period', label: `${t('contracts.filterModal.fields.period')}: ${periodLabel}` });
  }

  if (filters.financingType) {
    const found = options.financingTypes.find((f) => f.value === filters.financingType);
    chips.push({ key: 'financingType', label: `${t('contracts.filterModal.fields.financingType')}: ${found?.label ?? filters.financingType}` });
  }

  if (filters.model) {
    const found = options.models.find((m) => m.value === filters.model);
    chips.push({ key: 'model', label: `${t('contracts.filterModal.fields.model')}: ${found?.label ?? filters.model}` });
  }

  return chips;
};
